import { createFileRoute } from '@tanstack/react-router';

import { TicketTypesConfigPage } from '../modules/location-ticket-types-config/ui/pages/TicketTypesConfigPage';

// NOTE: .index.tsx suffix is REQUIRED here (same pattern as niche-config + tariff + zones + checkin-config routes).
// Without the .index suffix, TanStack Router treats the file as a layout component
// and wraps child routes instead of rendering the page. See JQ4-11 WU-13 gotcha.
export const Route = createFileRoute(
  '/_authenticated/dashboard/locations/$locationId/ticket-types-config/',
)({
  component: TicketTypesConfigPage,
  staticData: {
    breadcrumb: ['Manage', 'Locations', 'Ticket Types'],
  },
});
